import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'
const Services=()=> {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className='container services_container'>
        {/* <article className='service'>
          <div className='services_head'>
            <h3>Web designing</h3>
          </div>
          <ul className='service_list'>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>NetFlix Design </p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>Music Player Design </p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>My PortFolio Design </p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>In publishing and graphic design </p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>In publishing and graphic design </p>
          </li> 
          </ul>
        </article> */}
        {/* end of one section */}

        <article className='service'>
          <div className='services_head'>
            <h3>Front-End Development</h3>
          </div>
          <ul className='service_list'>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>Web Series Stream website Streaming Website </p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>Music Streaming website</p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>Video Streaming Website </p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>Amazon Clone </p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>Social Pedia </p>
          </li> 
          </ul>
        </article>
        {/* Web Development*/}

        <article className='service'>
          <div className='services_head'>
            <h3>Back-End Development</h3>
          </div>
          <ul className='service_list'>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>Full Stack Amazon </p>
          </li>
          <li>
            <BiCheck className='service_list_icon'/>
            <p>Social Pedia Website </p>
          </li>
         
          </ul>
        </article>
        {/* end of one section */}
      </div>
    </section >
  )
}

export default Services